import { createSelector } from 'helpers/reselect'

export const getFindLowerPrice = state => ({
  findLowerPrice: state.findLowerPrice
})

export const getPrice = createSelector(
  [getFindLowerPrice],
  ({
    findLowerPrice: {
      skuInformation: {
        listPrice
      } = {}
    } = {}
  }) => listPrice
)

export const getFindLowerPriceSkuId = createSelector(
  [getFindLowerPrice],
  ({
    findLowerPrice: {
      skuInformation: {
        skuId
      } = {}
    } = {}
  }) => skuId
)
